import { baseApiAuthenticated } from '@/api/v2/index';
import { urlBuilder } from '@/api/utils';
import { BackendType } from '@/models/general';
import {
    convertCouponFromResponse,
    Coupon,
    CreateCoupon,
} from '@/models/coupon';

import { prepareForRequest } from '@/utils/api';

const baseUrl = urlBuilder('order', 'coupons');

type GetCouponsResponse = {
    coupons: Coupon<BackendType>[];
};

export const couponApi = baseApiAuthenticated
    .enhanceEndpoints({ addTagTypes: ['COUPONS'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getCoupons: builder.query<Coupon[], void>({
                query: () => `${baseUrl}?size=1000`,

                transformResponse(response: GetCouponsResponse) {
                    return response.coupons.map(convertCouponFromResponse);
                },

                providesTags: ['COUPONS'],
            }),

            postCoupons: builder.mutation<Coupon, CreateCoupon>({
                query: (coupon) => {
                    const couponCopy = { ...coupon };

                    for (const key in couponCopy) {
                        if (couponCopy[key] === null) {
                            delete couponCopy[key];
                        }
                    }

                    return {
                        url: baseUrl,
                        method: 'POST',
                        body: prepareForRequest(couponCopy),
                    };
                },
                invalidatesTags: ['COUPONS'],
            }),
        }),
    });

export const { useGetCouponsQuery, usePostCouponsMutation } = couponApi;
